import React from 'react';
import type { ReactElement } from 'react';
import tw from 'twin.macro';

interface FadedImageProps {
  image: ReactElement;
}

export const fadedStyle = tw`h-full w-full object-cover opacity-60 xl:(absolute inset-0)`;
export const fadedImageStyle = tw`bg-right! object-cover`;

const FadedImage: React.FC<FadedImageProps> = ({ children, image }) => (
  <div tw="relative bg-gray-900 text-gray-50 overflow-hidden">
    <div tw="h-80 w-full absolute bottom-0 xl:(inset-0 h-full)">
      <div tw="h-full w-full xl:(grid grid-cols-2)">
        <div tw="h-full xl:(relative col-span-1 col-start-2)">
        {image}
        <div
            aria-hidden="true"
            tw="absolute inset-x-0 top-0 h-96 sm:(h-32) bg-gradient-to-b from-gray-900 xl:(inset-y-0 left-0 h-full w-32 bg-gradient-to-r)"
          />
        </div>
      </div>
    </div>
    <div tw="container">
      <div tw="mx-auto xl:(grid grid-cols-2 grid-flow-col-dense gap-x-8)">
        <div tw="relative pt-6 pb-32 sm:(pt-6 pb-64) lg:(pt-14 pb-64) xl:(col-start-1 pb-24)">{children}</div>
      </div>
    </div>
  </div>
);

export default FadedImage;
